<template>
  <div>
    <rj-tabs v-model="tabsActive">
      <rj-tab-pane name="1" label="电汇查询">
        <remittance-list />
      </rj-tab-pane>
      <rj-tab-pane name="2" label="已申请退款查询">
        <refund-query />
      </rj-tab-pane>
    </rj-tabs>
  </div>
</template>
<script type="es6">
import tabs from '@/components/Tabs/tabs';
import tabPane from '@/components/Tabs/tabPane';
import RemittanceList from '../remittanceList.vue';
import RefundQuery from './refund-query/Index.vue';

export default {
  data () {
    return {
      tabsActive: '1'
    };
  },

  components: {
    'rj-tab-pane': tabPane,
    'rj-tabs': tabs,
    RemittanceList,
    RefundQuery
  }
};
</script>
